import { spacing } from 'ext-ui/style/spacing'
import { transition_slow } from 'ext-ui/style/transitionSpeeds'
import { css } from 'styled-components'

export default css`
  & .icon-container {
    display: flex;
    align-items: center;
    &.small {
      gap: 0;
    }
    &.medium {
      gap: ${spacing(1)};
    }
  }

  & .clear-button {
    transition: opacity ${transition_slow};
  }

  & .dropdown-button,
  & .clear-button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: transparent;
    position: relative;
    &.small {
      width: 16px;
      height: 16px;
    }
    &.medium {
      width: 24px;
      height: 24px;
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

  & .icon {
    transition: transform ${transition_slow};
    transform: rotate(180deg);
    &.open {
      transform: rotate(0deg);
    }
  }

  & .animation-icon-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
